import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class ScreeningService {
  async getScreeningData() {
    try {
      const response = await axios.get(`${API}/screening/stocks`);
      return response.data;
    } catch (error) {
      console.error('Error fetching screening data:', error);
      throw error;
    }
  }
}

export default new ScreeningService();
